import React from "react";

function PageHero({ title, subtitle, imagePlaceholder }) {
  return (
    <section className="page-hero">
      <div className="page-hero-text">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
      <div className="page-hero-image">
        <div className="image-placeholder">
          <span>{imagePlaceholder || "Image Placeholder"}</span>
        </div>
      </div>
    </section>
  );
}

export default PageHero;
